import { setupEventHandlers } from "$javascript/lib/domHelpers.js"

class JUDEMagnetsElement extends HTMLElement {
  static {
    customElements.define("jude-magnets", this)
  }

  connectedCallback() {
    this.figure = this.querySelector("figure")
    const tmpl = this.querySelector("template")
    this.images = [...tmpl.content.children]
    this.currentIndex = 1

    setupEventHandlers(this, ["click"])
  }

  handleEvent() {
    if (this.images.length === 1) return

    const img = this.images[this.currentIndex]
    const showIndex = this.currentIndex + 1

    document.startViewTransition(() => {
      this.figure.firstElementChild.replaceWith(img)
      this.querySelector("wa-badge").textContent = showIndex
    })

    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0
    }
  }
}
